export default __webpack_public_path__ + "31174a6cdd727170c236f46cca514c4a.png";